import { Flex, Heading, Image, StackProps, Text, VStack } from "@chakra-ui/react";
import { ReactNode, useMemo } from "react";
export interface PlaceholderProperties extends StackProps {
  action?: ReactNode;
  descriptionSpacing?: string;
  image?: string;
  imageWidth?: number | string;
  inline?: boolean;
  subtitle?: string;
  title?: string;
}

export const Placeholder = ({
  action,
  children,
  descriptionSpacing,
  image,
  imageWidth,
  inline,
  subtitle,
  title,
  ...rest
}: PlaceholderProperties) => {
  const styleProperties: PlaceholderProperties = useMemo(
    () =>
      inline
        ? {
            justifyContent: "center",
            wrap: "wrap",
          }
        : {
            mt: 8,
            textAlign: "center",
            w: "full",
          },
    [inline],
  );

  return (
    <Flex
      direction={inline ? "row" : "column"}
      gap="6"
      {...styleProperties}
      alignItems="center"
      data-testid="placeholder"
      marginTop={0}
      {...rest}
    >
      {image && (
        <Image alt="placeholder" maxWidth={imageWidth ? undefined : "17em"} src={image} width={imageWidth ?? "33vw"} />
      )}
      {(title || subtitle || action) && (
        <VStack
          m={inline ? undefined : 6}
          maxWidth={imageWidth ?? "14em"}
          spacing={descriptionSpacing ?? 1}
          textAlign="center"
        >
          {title && <Heading fontSize="md">{title}</Heading>}
          {subtitle && <Text fontSize="sm">{subtitle}</Text>}
          {action}
        </VStack>
      )}
      {children}
    </Flex>
  );
};
